import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/goods/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/goods/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 导出模板
export function exportDoc (params) {
  return request.post('/business/goods/export', params, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/goods/create', data)
}

// 企业新建商品
export function companyCreate (data) {
  return request.post('/business/goods/companyCreate', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/goods/updateById', data)
}

// 企业根据ID修改
export function companyUpdateById (data) {
  return request.post('/business/goods/companyUpdateById', data)
}

// 批量修改状态
export function batchUpdateDisableById (data) {
  return request.post('/business/goods/batchUpdateDisableById', data)
}

// 从平台选择商品
export function createPlat (data) {
  return request.post('/business/goods/createPlat', data)
}

// 分页查询
export function pageT (data) {
  return request.post('/business/baseGoods/page', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/goods/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/goods/delete/batch', {
    params: {
      ids
    }
  })
}

// 修改状态
export function updateDisableById (data) {
  return request.post('/business/goods/updateDisableById', data)
}

// 列表 - 商品选择
export function findListForGoodsId (goodsId) {
  return request.get(`/business/category/findListForGoodsId?goodsId=${goodsId}`)
}

// 根据ID查询
export function queryById (id) {
  return request.get(`business/goods/${id}`)
}